import { Component, inject, input, signal } from '@angular/core';
import { ContactFormService } from '../contact-form/contact-form.service';
import {
  FaIconComponent,
  FaLayersComponent,
} from '@fortawesome/angular-fontawesome';
import {
  faFacebook,
  faInstagram,
  faLinkedin,
  faWhatsapp,
} from '@fortawesome/free-brands-svg-icons';
import {
  faCircle,
  faEnvelope,
  faFileContract,
  faLocationDot,
  faPhone,
} from '@fortawesome/free-solid-svg-icons';
import { GlobalService } from '../services/global.service';

@Component({
  selector: 'app-footer',
  imports: [FaIconComponent, FaLayersComponent],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  private contactFormService = inject(ContactFormService);

  private globalService = inject(GlobalService);
  icons = {
    facebook: faFacebook,
    instagram: faInstagram,
    linkedin: faLinkedin,
    whatsapp: faWhatsapp,
    address: faLocationDot,
    email: faEnvelope,
    phone: faPhone,
    circle: faCircle,
    policy: faFileContract,
  };
  showFooterCTA = signal(true);

  constructor() {
    this.globalService.shouldShowFooterCTA.subscribe((show) => {
      this.showFooterCTA.set(show);
    });
  }

  onEstimateClick() {
    this.contactFormService.openForm('footer');
  }
}
